export default __webpack_public_path__ + "static/media/2.08d0a2f6.png";